import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#0A3D2F] text-white/80 py-16">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-y-12">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo-icon.png" alt="VeedumParambum" className="h-9 w-9" />
            <span className="text-white text-2xl font-semibold tracking-tight">VeedumParambum</span>
          </div>
          <p className="text-sm max-w-xs">
            Kerala's premier AI-powered real estate platform. Premium homes. Verified sellers. Built for everyday buyers and sellers.
          </p>
        </div>
        <div>
          <div className="font-semibold text-white mb-4">Explore</div>
          <div className="space-y-2 text-sm">
            <div>Search Properties</div>
            <div>Property Help</div>
            <div>Buyer guides</div>
          </div>
        </div>
        <div>
          <div className="font-semibold text-white mb-4">For Professionals</div>
          <div className="space-y-2 text-sm">
            <div>List Your Property</div>
            <div>Agent Portal</div>
            <div>Featured Listings</div>
          </div>
        </div>
        <div>
          <div className="font-semibold text-white mb-4">Company</div>
          <div className="space-y-2 text-sm">
            <div>About Us</div>
            <div>Trust & Safety</div>
            <div>Contact</div>
          </div>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 text-center text-xs tracking-widest text-white/50">
        © {new Date().getFullYear()} VeedumParambum. The benchmark for premium real estate in Kerala.
      </div>
    </footer>
  );
};

export default Footer;
